/**
 * @license
 * Copyright Alibaba.com All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ant-reset-private/blob/master/LICENSE
 */

export default {
  // Options.jsx
  items_per_page: '/ stronÄ',
  jump_to: 'IdÅº do',
  jump_to_confirm: 'potwierdzaÄ',
  page: '',

  // Pagination.jsx
  prev_page: 'Poprzednia strona',
  next_page: 'NastÄpna strona',
  prev_5: 'Poprzednie 5 stron',
  next_5: 'NastÄpne 5 stron',
  prev_3: 'Poprzednie 3 strony',
  next_3: 'NastÄpne 3 strony'
};
